<div class="Loader" *ngIf="active">
  <mat-progress-bar  mode="indeterminate"></mat-progress-bar>
</div>